import { useSyncExternalStore } from 'react';

/**
 * De opnames die nu naar dit apparaat onderweg zijn, omdat iemand ze net startte.
 *
 * Een keuring starten gebeurt op de server; daarna moeten de opname en haar vragenlijst
 * nog binnenkomen. Duurt dat langer dan de knop wil wachten, dan opent het opnamescherm
 * toch al — en zegt het "De opname wordt klaargezet" in plaats van "staat niet op dit
 * apparaat", zolang deze lijst hem noemt. Het ophalen zelf haalt hem eraf, gelukt of niet.
 */
const preparing = new Set<string>();
const listeners = new Set<() => void>();

function emit(): void {
    listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void): () => void {
    listeners.add(listener);

    return () => listeners.delete(listener);
}

export function markPreparing(inspectionUuid: string): void {
    preparing.add(inspectionUuid);
    emit();
}

export function donePreparing(inspectionUuid: string): void {
    if (preparing.delete(inspectionUuid)) {
        emit();
    }
}

export function isPreparing(inspectionUuid: string): boolean {
    return preparing.has(inspectionUuid);
}

export function useIsPreparing(inspectionUuid: string): boolean {
    return useSyncExternalStore(
        subscribe,
        () => preparing.has(inspectionUuid),
        () => false,
    );
}
